import NavigationBar from "../../components/navigationBar";
import GenericPromotionalOfferComponent from "../../components/promotinal-pages/genericPromotionalOfferComponent";
import FooterView from "../../components/footerView";


export default function GenericPromotionalPage() {


    return (
        <div>
            <NavigationBar shouldHidePromotionalBanner={true} />
            <GenericPromotionalOfferComponent />
            <FooterView />
        </div>
    )
}